(function(){
    angular
        .module('appback')
        .directive('ngTodecimalalt', ngTodecimalalt);

        ngTodecimalalt.$inject = ['$timeout'];
        function ngTodecimalalt($timeout){
            return {
	            require: 'ngModel',
	            scope: {
	            	numdecimales:'='
	            },
	            link: function(scope, element, attrs, ngModel) {
	            	var ctrlDown = false;
	            	element.on('keydown', function (event) {  
		                var $input = $(this);  
		                var value = $input.val();  
		                value = value.replace(/[^0-9,.]/g, '')  
		                $input.val(value);
		                //console.log(event.which);  
		                if (event.which == 64 || event.which == 16) {  
		                    // to allow numbers  
		                    return false;  
		                } else if (event.which >= 48 && event.which <= 57) {  
		                    // to allow numbers  
		                    return true;  
		                } else if (event.which >= 96 && event.which <= 105) {  
		                    // to allow numpad number  
		                    return true;  
		                } else if ([17, 86].indexOf(event.which) > -1) {  
		                    // to allow CONTROL +V
		                    return true;  
		                } else if ([8, 13, 27, 37, 38, 39, 40, 9,  17].indexOf(event.which) > -1) {  
		                    // to allow backspace, enter, escape, arrows, tab
		                    return true;  
		                }else if ([188,190,110].indexOf(event.which) > -1) {  
		                    // to allow backspace, enter, escape, arrows  
		                    return true;  
		                } else {  
		                    event.preventDefault();  
		                    // to stop others  
		                    //alert("Sorry Only Numbers Allowed");  
		                    return false;  
		                }  
		            });  
	            	ngModel.$parsers.push(function (inputValue) {
		                if (inputValue == null)
		                    return ''
			      		var valor = inputValue.replace(',', '.');
			      		ngModel.$setViewValue(valor);
			      		ngModel.$render();
		                return valor;
		            });
			      
			      /*ngModel.$formatters.push(function(value) {
	            	console.log("tocecimal2");
			      	    return value ? parseFloat(value).toFixed(2).toString().replace(',', '.') : null;
			      });*/
				}
        	}
        }
})();